import { TOKEN_LOGOS } from "./logos";

interface TokenMetadata {
  icon: string;
  name: string;
  symbol: string;
}

export const TOKEN_METADATA: Record<string, TokenMetadata> = {
  // Mock USDC address for local development
  "0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b": {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  "0x4e967b56244253a810dcc5935b821d9e5c9641f291ee094b88678200dc1105ba": {
    icon: TOKEN_LOGOS.BTC,
    name: "Bitcoin",
    symbol: "BTC",
  },
  "0xf6d13ca84aaaa39ad1f6e148a0fc3732d3abe5e11e00c2f7864457b192883690": {
    icon: TOKEN_LOGOS.BTC,
    name: "Bitcoin",
    symbol: "BTC",
  },
  "0x62ca6ae4aa9813903196428ffcae0ba597339073b9259e94eecd82128524e99d": {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  "0x6208945221b7430d1083e5967d812c0f40cc89682923305429704f89f3f28a86": {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  "0x77907344e317543f8b66e7594501f1dcb2cf6f6124f88d7194208e5b8b48a456": {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  "0xb82fb8815d9f5711936ad96332f2e4fdf309d4a138f75f5ccbf7ce1aa02f2151": {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  "0xa": {
    icon: TOKEN_LOGOS.APTOS,
    name: "Aptos",
    symbol: "APT",
  },
  "0x000000000000000000000000000000000000000000000000000000000000000a": {
    icon: TOKEN_LOGOS.APTOS,
    name: "Aptos",
    symbol: "APT",
  },
  "0x0000000000000000000000000000000000000000000000000000000000000001::aptos_coin::aptoscoin": {
    icon: TOKEN_LOGOS.APTOS,
    name: "Aptos",
    symbol: "APT",
  },
  "0x58d57095c284c41c758f97b3efeb7c1e09e5a46c5e65a6feb8a5a8b9c93afed6": {
    icon: TOKEN_LOGOS.APTOS,
    name: "Aptos",
    symbol: "APT",
  },
  "0x32266e114d835315a4448493611b4bc3482368e1e522e38d48c74ad64eedce21": {
    icon: TOKEN_LOGOS.ETH,
    name: "Ethereum",
    symbol: "ETH",
  },
  "0x9a155939f4fc9444834e93b42656c9bbc5f4501d32efc7611d054d52bd5925ce": {
    icon: TOKEN_LOGOS.ETH,
    name: "Ethereum",
    symbol: "ETH",
  },
  "0xd61d6e65387d21bc5cd7a77f350a86c85648229b12540c13b0207dc69b3e3f69": {
    icon: TOKEN_LOGOS.ENA,
    name: "ENA",
    symbol: "ENA",
  },
  "0x329ffa4ab797afc62c330b11aca55ec190630968b5359655e771582c9b518c60": {
    icon: TOKEN_LOGOS.ENA,
    name: "ENA",
    symbol: "ENA",
  },
  "0x1f7cd9d35612a7c6d00d62e13e54d325b02547848c182566467532ea2ace5461": {
    icon: TOKEN_LOGOS.HYPE,
    name: "Hyperliquid",
    symbol: "HYPE",
  },
  "0xc62aeb12cf5cad1992164f99c50af4f5ee719b898f14db9fc6c6ce395e2c408b": {
    icon: TOKEN_LOGOS.HYPE,
    name: "Hyperliquid",
    symbol: "HYPE",
  },
  "0x93872aa5e07f05d442c9b06918578caa78450898ff223bd3f9b1dd7bf94c614b": {
    icon: TOKEN_LOGOS.SOL,
    name: "Solana",
    symbol: "SOL",
  },
  "0x22e17f69fba719afa5b10717b81bc855ee085e6e6a84c62f69dcc88c3facb173": {
    icon: TOKEN_LOGOS.SOL,
    name: "Solana",
    symbol: "SOL",
  },
};

export const TOKEN_METADATA_BY_SYMBOL: Record<string, TokenMetadata> = {
  BTC: {
    icon: TOKEN_LOGOS.BTC,
    name: "Bitcoin",
    symbol: "BTC",
  },
  USDC: {
    icon: TOKEN_LOGOS.USDC,
    name: "USDC",
    symbol: "USDC",
  },
  APT: {
    icon: TOKEN_LOGOS.APTOS,
    name: "Aptos",
    symbol: "APT",
  },
  ETH: {
    icon: TOKEN_LOGOS.ETH,
    name: "Ethereum",
    symbol: "ETH",
  },
  ENA: {
    icon: TOKEN_LOGOS.ENA,
    name: "ENA",
    symbol: "ENA",
  },
  HYPE: {
    icon: TOKEN_LOGOS.HYPE,
    name: "Hyperliquid",
    symbol: "HYPE",
  },
  SOL: {
    icon: TOKEN_LOGOS.SOL,
    name: "Solana",
    symbol: "SOL",
  },
};

export const getBaseSymbolFromMarket = (marketSymbol: string): string => {
  let symbol = marketSymbol.split("-")[0];
  if (symbol.startsWith("W")) {
    symbol = symbol.substring(1);
  }
  return symbol;
};
